import $ from 'jquery'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.map-block__map')

  if (!wrapper.length) {
    return
  }

  wrapper.find('path').on('click', function () {
    window.open($(this).attr('data-url'), '_blank').focus()
  })
}

$('.map-block').each(function () {
  if ($('.acf-block-preview').length) return

  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=smat-map', initializeBlock)
}
